/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Register_Sign_In_HintInputs */

const en_auth_register_sign_in_hint = /** @type {(inputs: Auth_Register_Sign_In_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account? Sign in`)
};

const es_auth_register_sign_in_hint = /** @type {(inputs: Auth_Register_Sign_In_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes cuenta? Inicia sesion`)
};

/**
* | output |
* | --- |
* | "Already have an account? Sign in" |
*
* @param {Auth_Register_Sign_In_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_register_sign_in_hint = /** @type {((inputs?: Auth_Register_Sign_In_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Register_Sign_In_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_register_sign_in_hint(inputs)
	return es_auth_register_sign_in_hint(inputs)
});